import { render } from "./artworks.vue?vue&type=template&id=7140f719&scoped=true"
import script from "./artworks.vue?vue&type=script&lang=js"
export * from "./artworks.vue?vue&type=script&lang=js"

import "./artworks.vue?vue&type=style&index=0&id=7140f719&scoped=true&lang=css"

import exportComponent from "/var/www/artsys-st/artch-artsys/Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7140f719"]])

export default __exports__